<template>
  <div class="d-flex flex-column align-items-stretch flex-shrink-0 bg-white">
    <div
      class="d-flex p-4 align-items-center flex-shrink-0 p-2 link-dark text-decoration-none border-bottom"
    >
      <div class="mx-auto"><NewtonsCradle /></div>
    </div>
    <div class="list-group list-group-flush border-bottom scrollarea">
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Account No</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Company Name</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Account Holder</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Account Type</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">PPS Package</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Account Claims</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-12 mb-1 small">
          <ul class="list-group "></ul>
        </div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">RITA Status</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-2 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Call Routing Account Status</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
      <div
        class="list-group-item list-group-item-action py-1 lh-tight tab bg-gradient"
        aria-current="true"
      >
        <div class="d-flex w-100 align-items-center justify-content-between">
          <strong class="mb-1 title">Billing Account Status</strong>
          <small><i class="bi bi-dot"></i></small>
        </div>
        <div class="col-10 mb-1 small title">...</div>
      </div>
    </div>
  </div>
</template>

<script>
import NewtonsCradle from "@/components/NewtonsCradle.vue";
export default {
  components: {
    NewtonsCradle,
  },
};
</script>

<style scoped>
.title {
  animation: pulse-bg 1s infinite;
}
@keyframes pulse-bg {
  0% {
    color: #eee;
  }
  50% {
    color: #eaeaea;
  }
  100% {
    color: #eee;
  }
}
</style>
